import type { LimosaDetail, MyLimosaStatus } from '@/api/administratie';

export type LimosaTone = 'groen' | 'oranje' | 'rood' | 'blauw' | 'grijs';

export interface LimosaLine {
  label: string;
  tone: LimosaTone;
  /** Missing, expired or rejected: the person needs a new upload. */
  canUpload: boolean;
}

/** `YYYY-MM-DD` → `dd/mm`. */
export function dayMonth(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${d}/${m}`;
}

/**
 * What one person's Limosa line on a job card says. The badge itself comes from
 * the API (utils/limosa-status.ts, the administratie logic, on the card's date);
 * this only words it, and for "rood" tells missing, expired and rejected apart
 * from the person's latest declaration. Only called for people who need a Limosa.
 */
export function limosaLine(status: MyLimosaStatus | undefined, records: LimosaDetail[], date: string): LimosaLine {
  switch (status?.badge) {
    case 'groen':
      return { label: `geldig t/m ${dayMonth(status.geldigTot!)}`, tone: 'groen', canUpload: false };
    case 'oranje':
      return { label: `geldig t/m ${dayMonth(status.geldigTot!)}`, tone: 'oranje', canUpload: false };
    case 'te_controleren':
      return { label: 'te controleren', tone: 'blauw', canUpload: false };
    default: {
      const latest = records
        .filter((r) => r.partnerId === status?.partnerId)
        .sort((a, b) => b.geldigTot.localeCompare(a.geldigTot) || b.id - a.id)[0];
      if (latest?.status === 'afgekeurd') return { label: 'afgekeurd', tone: 'rood', canUpload: true };
      if (latest && latest.geldigTot < date) return { label: 'verlopen', tone: 'rood', canUpload: true };
      return { label: 'ontbreekt', tone: 'rood', canUpload: true };
    }
  }
}
